// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + "app" + "." + "41a8b75ee772c5418dda" + ".css";
};